import 'lib/polyfill'
import { isIEorEdge, set } from 'lib/util'
import 'styles/main.css'
import { initSentry } from '../../lib/sentry'
import initRecharge from '../../lib/recharge'
import initAccessibility from '../../lib/accessibility';

// initSentry()

initRecharge()

document.addEventListener('DOMContentLoaded', () => {
  if (isIEorEdge()) set(document.body, 'ie')

  initAccessibility(); // Initialize accessibility improvements

  async function redirectAfterLogout() {
    const res = await fetch('/account/logout')
    if (res) {
      window.location.href = '/pages/logout'
    }
  }

  const buttonLogout = document.querySelectorAll('.js-button-logout')

  if (buttonLogout.length) {
    buttonLogout.forEach((button) => {
      button.addEventListener('click', () => redirectAfterLogout())
    })
  }
})

/* eslint-disable */
__webpack_public_path__ = SHOPIFY_CDN;
/* eslint-enable */
